import React from "react";
import { Icons } from "../../components/common/Icons";
import { useEmployeeData } from "../../context/EmployeeContext";import "../../assets/styles/Employee/EmpTimelinePage.css";

function EmpTimelinePage() {
  const { empTimeline, empExperience } = useEmployeeData();

  const colors = { join: ["#eff6ff", "#bfdbfe", "#2563eb"], team: ["#eff6ff", "#bfdbfe", "#3b82f6"], asset: ["#faf5ff", "#e9d5ff", "#8b5cf6"], role: ["#eef2ff", "#c7d2fe", "#4f46e5"], salary: ["#fffbeb", "#fde68a", "#f59e0b"], review: ["#fef2f2", "#fecaca", "#ef4444"] };

  const exp = empExperience || {};
  const expYears = exp.experience_months ? Math.floor(exp.experience_months / 12) : 0;
  const expMonths = exp.experience_months ? exp.experience_months % 12 : 0;

  // Group timeline by year
  const grouped = {};
  (empTimeline || []).forEach((e) => {
    const yr = e.dt ? (e.dt.match(/\d{4}/) || ['Other'])[0] : 'Other';
    if (!grouped[yr]) grouped[yr] = [];
    grouped[yr].push(e);
  });
  const years = Object.keys(grouped).sort((a, b) => b - a);

  return (
    <div>
      {/* Experience Summary */}
      {exp.joining_date &&
      <div className="card animate-in mb-24">
          <div className="card-header"><div className="card-title">Experience Summary</div></div>
          <div className="card-body">
            <div className="stats-grid-4">
              {[
            [exp.joining_date ? new Date(exp.joining_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—', 'Joining Date', '#4f46e5'],
            [exp.experience_months ? `${expYears}y ${expMonths}m` : '—', 'Total Experience', '#2563eb'],
            [exp.designation || '—', 'Designation', '#2563eb'],
            [exp.team || '—', 'Team', '#f59e0b']].
            map(([v, l, c], i) =>
            <div className="stat-item" key={i}><div className="stat-value emptimelinepage-dyn-1" style={{ "--emptimelinepage-1-color": c, "--emptimelinepage-1-font-size": `${typeof v === 'string' && v.length > 8 ? 12 : 16}px` }}>{v}</div><div className="stat-label">{l}</div></div>
            )}
            </div>
          </div>
        </div>
      }

      {/* Year-wise Timeline */}
      {years.length > 0 ? years.map((yr) =>
      <div key={yr} className="card animate-in mb-24">
          <div className="card-header"><div className="card-title">{yr}</div><div className="card-subtitle">{grouped[yr].length} events</div></div>
          <div className="card-body">
            {grouped[yr].map((e, i) => {
            const c = colors[e.tp] || colors.join;
            return (
              <div key={i} className="timeline-item">
                  {i < grouped[yr].length - 1 && <div className="timeline-line" />}
                  <div className="timeline-dot emptimelinepage-dyn-2" style={{ "--emptimelinepage-2-background": c[0], "--emptimelinepage-2-border": `2px solid ${c[1]}` }}><div style={{ "--emptimelinepage-3-background": c[2] }} className="emptimelinepage-dyn-3" /></div>
                  <div className="timeline-content">
                    <div className="timeline-date">{e.dt}</div>
                    <div className="timeline-title">{e.t}</div>
                    <div className="timeline-desc">{e.d}</div>
                  </div>
                </div>);

          })}
          </div>
        </div>
      ) :
      <div className="card animate-in">
          <div className="card-body emptimelinepage-inline-1">
            <div className="emptimelinepage-inline-2">📋</div>
            <div>No timeline events yet</div>
          </div>
        </div>
      }
    </div>);

}

export default EmpTimelinePage;